import './index.less';
import React from 'react';
import moment from 'moment';
import { Button, Select, Message } from 'antd';
import { postChangeCourse } from '../../api/index.js';

const Option = Select.Option;
const week = {
  1: '周一',
  2: '周二',
  3: '周三',
  4: '周四',
  5: '周五',
  6: '周六',
  0: '周天',
}

const submitChange = (offset, data, date, clock, refreshData, handleCancel) => {
  console.log(date);
  if (!data) {
    Message.warn('请选择日期');
    return
  }
  if (!clock) {
    Message.warn('请选择时间');
    return
  }
  postChangeCourse({
    offset: offset,
    schedule_id: data.get('id'),
    course_id: data.get('lesson').get('course_id'),
    start_time: `${date} ${clock}`,
  }).then(res => {
    if (res.code === 200) {
      Message.success('调课成功');
      refreshData();
      handleCancel();
      return
    }
    Message.error(res.tip);
  })
}

const Adjust = ({ 
  day,
  data,
  date,
  time,
  clock,
  offset,
  renderTime,
  renderDate,
  changeDate,
  changeMonth,
  defaultTime,
  refreshData,
  handleCancel
}) => {
  return (
    <div>
      <div className='content-item'>
        <span className='contentName'>上课教师：</span> 
        <span>{data.get('teacher').get('name')}</span>
      </div>  
      <div className='content-item'>
        <span className='contentName'>原上课时间：</span> 
        <span>{data.get('from_time')} {week[moment(data.get('from_time')).day()]}</span>
      </div>
      <div className='content-item'>
        <span className='contentName'>更换上课时间为：</span>
        <span className='select-container'>
          <Select defaultValue='0' style={{ width: 140 }} onChange={changeMonth}>
            <Option value='0'>请选择日期</Option>
            {
              day && renderDate(day)
            }
          </Select>
        </span>
        <span className='select-container'>
          <Select value={defaultTime} style={{ width: 140 }} onChange={changeDate}>
            <Option value='0'>请选择时间</Option>
            {
              time && renderTime(time)
            }
          </Select>
        </span>
      </div>
      <div className='dialog-btn'>
        <Button className='confirmbtn' onClick={() => submitChange(offset, data, date, clock, refreshData, handleCancel)}>确 定</Button>
      </div>
      <div className='notes'>
        <p>调课须知：</p>
        <p>1.可选择12小时之后的课程</p>
        <p>2.学生可在开课12小时外调课</p>
      </div>
    </div>
  )
}

export default Adjust;


// WEBPACK FOOTER //
// ./src/components/dialog/adjust.jsx